import dayjs from "dayjs";
import qs from "qs";
import {
    ID_FILTER_REPORT_DEALERS,
    ID_FILTER_REPORT_FILE_NAME,
    ID_FILTER_REPORT_IMPORT_DATE_FROM,
    ID_FILTER_REPORT_IMPORT_DATE_TO,
    ID_FILTER_REPORT_LEGAL_ENTITIES,
    ID_FILTER_REPORT_SEQUENCE_NUMBER,
    ID_FILTER_REPORT_STATUSES,
    ID_FILTER_REPORT_TOLLS_NUMBER,
    ID_FILTER_REPORT_VERSION,
    ID_FILTER_SEARCH
} from "../../pages/etoll/constants/ETollConstants";
import {FilterDef, HTTPGenericResponse} from "../../constants/FinanceModels";
import {getFilterValue} from "../../utils/FilterUtils";
import {useApi} from "../Api";
import {useContext} from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";

export const useETollReportRepository = () => {

    const {GET} = useApi();

    const PATH = "/finance/etoll/report"

    const {globalData: {user}} = useContext(GlobalContext);
    const allLegalEntities: any[] = user.legalEntities?.filter((x: any) => x.name.toLowerCase() !== "all").map((x: any) => x.name);


    async function getReports(offset: number, limit: number, sort: string | null, order: string | null, filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let fileName = getFilterValue(ID_FILTER_REPORT_FILE_NAME, filterDefs);
        let dateFrom: Date = getFilterValue(ID_FILTER_REPORT_IMPORT_DATE_FROM, filterDefs);
        let dateTo: Date = getFilterValue(ID_FILTER_REPORT_IMPORT_DATE_TO, filterDefs);
        let sequenceNumber = getFilterValue(ID_FILTER_REPORT_SEQUENCE_NUMBER, filterDefs);
        let version = getFilterValue(ID_FILTER_REPORT_VERSION, filterDefs);
        let tollsNumber = getFilterValue(ID_FILTER_REPORT_TOLLS_NUMBER, filterDefs);
        let status = getFilterValue(ID_FILTER_REPORT_STATUSES, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_REPORT_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_REPORT_DEALERS, filterDefs);

        let params = {
            offset: offset,
            limit: limit,
            sort: sort,
            order: order,
            search: search,
            fileName: fileName,
            from: dateFrom ? dayjs(dateFrom).toISOString() : null,
            to: dateTo ? dayjs(dateTo).toISOString() : null,
            sequenceNumber: sequenceNumber,
            version: version,
            tollsNumber: tollsNumber,
            status: status,
            legalEntities,
            dealers
        }

        let response = await GET(`${PATH}/all`, {
            params: params,
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return new Promise((resolve) => {
            let generic: HTTPGenericResponse = {
                code: 200,
                status: 'OK',
                message: '',
                result: response
            }
            resolve(generic);
        })
    }

    function getReportById(id: string, config?: any): Promise<HTTPGenericResponse> {
        return GET(`${PATH}/${id}`, config);
    }

    function getSummary(filterDefs: FilterDef[] = []): Promise<HTTPGenericResponse> {
        let search = getFilterValue(ID_FILTER_SEARCH, filterDefs);
        let fileName = getFilterValue(ID_FILTER_REPORT_FILE_NAME, filterDefs);
        let dateFrom: Date = getFilterValue(ID_FILTER_REPORT_IMPORT_DATE_FROM, filterDefs);
        let dateTo: Date = getFilterValue(ID_FILTER_REPORT_IMPORT_DATE_TO, filterDefs);
        let sequenceNumber = getFilterValue(ID_FILTER_REPORT_SEQUENCE_NUMBER, filterDefs);
        let version = getFilterValue(ID_FILTER_REPORT_VERSION, filterDefs);
        let tollsNumber = getFilterValue(ID_FILTER_REPORT_TOLLS_NUMBER, filterDefs);
        let status = getFilterValue(ID_FILTER_REPORT_STATUSES, filterDefs);
        let legalEntities: string[] = getFilterValue(ID_FILTER_REPORT_LEGAL_ENTITIES, filterDefs) || allLegalEntities;
        let dealers: string[] = getFilterValue(ID_FILTER_REPORT_DEALERS, filterDefs);

        let params = {
            search: search,
            fileName: fileName,
            from: dateFrom ? dayjs(dateFrom).toISOString() : null,
            to: dateTo ? dayjs(dateTo).toISOString() : null,
            sequenceNumber: sequenceNumber,
            version: version,
            tollsNumber: tollsNumber,
            status: status,
            legalEntities,
            dealers
        }

        return GET(`${PATH}/all-status-summary`, {
            params: params,
            paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
    }


    return {getReports, getReportById, getSummary};
}